<div class="modal-header">
  <!-- <h4 class="modal-title"> Welcome </h4> -->
  <h4 class="modal-title">{{ title }}</h4>
  <button class="btn btn-link p-0" (click)="activeModal.dismiss()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body" [innerHtml]="message"></div>
